import { Body, cn } from '@growtherapy/sprout-ui';

export type BackgroundButtonProps = {
  image?: string;
  altText?: string;
  text?: string;
  isDisabled?: boolean;
  isSelected: boolean;
  onClick: () => void;
  isLarge?: boolean;
  isMirrored?: boolean;
  color?: string;
  hasBorder?: boolean;
  isDarkTheme: boolean;
};

export function BackgroundButton({
  image,
  altText,
  text,
  isDisabled = false,
  isSelected,
  onClick,
  isLarge = false,
  isMirrored = true,
  color,
  hasBorder = false,
  isDarkTheme,
}: BackgroundButtonProps) {
  return (
    <button
      disabled={isDisabled}
      onClick={onClick}
      className={cn(
        'h-20 w-full rounded-2xl focus:outline-2 focus:outline-lilac-700 focus:outline focus:outline-offset-2 rebrand:outline-border-subtle',
        {
          'cursor-not-allowed': isDisabled,
          'outline-2 outline-lilac-700 outline outline-offset-2 rebrand:outline-border-state-selected-default':
            isSelected,
          'outline-neutral-400 rebrand:outline-border-state-inactive-default': isDisabled,
          'border border-neutral-400 rebrand:border-border-subtle': hasBorder,
          'h-24': isLarge,
          relative: !!text,
          'bg-neutral-900 rebrand:bg-surface-inverse': !image && !color,
        },
        color,
      )}
    >
      {image && (
        <img
          src={image}
          alt={altText ?? ''}
          className={cn('rounded-2xl h-full object-cover w-full', {
            'h-24': isLarge,
            'scale-x-[-1]': isMirrored,
          })}
        />
      )}
      {text && (
        <Body.Small
          emphasis
          as='span'
          className={cn('text-small font-medium text-neutral-100', {
            'rebrand:text-text-inverse': isDarkTheme,
            'absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2': !!image,
          })}
        >
          {text}
        </Body.Small>
      )}
    </button>
  );
}
